import type { FC, ReactNode } from 'react';

import styles from './FieldBlock.module.scss';

interface IFieldBlock {
  label?: string | ReactNode;
  id?: string;
  size?: 'half' | 'col-3' | 'col-4' | 'col-6' | 'content';
  labelSize?: 'col-2' | 'col-3' | 'col-4';
  labelFontSize?: 'small' | 'medium';
  placementLabel?: 'left';
  color?: 'black';
  type?: 'stretch-column' | 'not-space' | 'flex-label' | 'grow-label';
  button?: ReactNode;
  fillInProcess?: ReactNode;
  labelId?: string;
  className?: string;
  margin?: 'right' | 'top' | 'bottom';
  alignItemsEnd?: 'true';
  tooltip?: ReactNode;
  warning?: string;
  error?: string;
  success?: string;
  blackGroup?: boolean;
}

export const FieldBlock: FC<IFieldBlock> = ({
  children,
  label,
  id,
  size,
  placementLabel,
  color,
  button,
  fillInProcess,
  type,
  labelId,
  labelSize,
  labelFontSize,
  className,
  margin,
  alignItemsEnd,
  tooltip,
  warning,
  error,
  success,
  blackGroup,
}) => {
  const fieldBlockAttributes = {
    ...(size === 'half' && { 'data-half': true }),
    ...(size === 'col-3' && { 'data-thirteen': true }),
    ...(size === 'col-4' && { 'data-fourth': true }),
    ...(size === 'col-6' && { 'data-sixth': true }),
    ...(size === 'content' && { 'data-content': true }),
    ...(placementLabel === 'left' && { 'data-left': true }),
    ...(type === 'stretch-column' && { 'data-stretch': true }),
    ...(margin === 'right' && { 'data-margin-right': true }),
    ...(margin === 'top' && { 'data-margin-top': true }),
    ...(margin === 'bottom' && { 'data-margin-bottom': true }),
    ...(type === 'not-space' && { 'data-not-space': true }),
    ...(alignItemsEnd === 'true' && { 'data-align-items-end': true }),
  };

  const labelContainerAttributes = {
    ...(placementLabel === 'left' && { 'data-left': true }),
    ...(labelSize === 'col-4' && { 'data-fourth-size': true }),
    ...(labelSize === 'col-3' && { 'data-thirteen-size': true }),
    ...(labelSize === 'col-2' && { 'data-half-size': true }),
    ...(type === 'flex-label' && { 'data-flex': true }),
    ...(type === 'grow-label' && { 'data-grow': true }),
  };

  const labelAttributes = {
    ...(!color && { 'data-group': true }),
    ...(color === 'black' && { 'data-black': true }),
    ...(blackGroup && { 'data-black-group': true }),
    ...(labelFontSize === 'small' && { 'data-small': true }),
    ...(labelFontSize === 'medium' && { 'data-medium': true }),
  };

  return (
    <div className={`${styles.FieldBlock} ${className}`} id={id} {...fieldBlockAttributes}>
      {fillInProcess}
      {label && (
        <div className={styles.LabelContainer} id={labelId} {...labelContainerAttributes}>
          <label className={styles.Label} {...labelAttributes}>
            {label}
          </label>
          {warning && <p className={styles.Warning}>{warning}</p>}
          {error && <p className={styles.Error}>{error}</p>}
          {success && <p className={styles.Success}>{success}</p>}
          {tooltip}
          {button}
        </div>
      )}
      {children}
    </div>
  );
};
